export enum VettingDetailsTabsEnum {
    PROFILE = 'PROFILE',
    PDF_CV = 'PDF_CV',
    CHAT = 'CHAT',
    WHATSAPP_CHAT = 'WHATSAPP_CHAT',
    INTERVIEW_CONVERSATION = 'INTERVIEW_CONVERSATION',
    NOTES = 'NOTES',
    SCREENING_QUESTIONS = 'SCREENING_QUESTIONS',
    EVALUATION_FORM = 'EVALUATION_FORM',
    UPLOADED_DOCUMENTS = 'UPLOADED_DOCUMENTS',
}